// extracted by mini-css-extract-plugin
module.exports = {"gou":"SectionSorting_gou__ytr7a","selected":"SectionSorting_selected__BiwF7"};